import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrl: './header-menu.component.css'
})
export class HeaderMenuComponent {
  @Input() isScrolled: any = {};
  global: any = GlobalConstants;

  constructor(private query: QueryService,
              public router: Router) {}

  goOpcion(url:string) {
    window.location.href = GlobalConstants.urlServer + url;
  }

  isActive(url: string): boolean {
    const currentPath = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    if (url === '')
      return (GlobalConstants.urlServer.replace(/\/$/, '') === currentPath.replace(/\/$/, ''));
    else
      return currentPath.includes(GlobalConstants.urlServer + url);
  }
}
